import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss',
  '../../../../../../assets/sass/pages/page-users.scss',
  '../../../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None 
})

export class EditComponent implements OnInit {
  businessId:any;
  imageUrl=environment.apiUrls.imageUrl;

  imgUrl:any;
  businessData={
    name:'',
    about:'',
    email:'',
    admin_notes:'',
    website:'',
    facebook_url:'',
    linked_url:'',
    phone:'',
    address:'',
    notes:'',
    type:'',
    refrences:''
    
  };
  categoryList: any;
  selected_type=null
  constructor(private apiService:ApiService,
    private route:Router,
    public toastr: ToastrService,
    private activatedroute:ActivatedRoute) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.businessId = params.get('id'); 
  });
  this.getTagByCategory()
   }

  ngOnInit(): void {this.getBusinessById()
  }
  getBusinessById(){
    this.apiService.getBusinessById(this.businessId).subscribe((res:any)=>{
      if(res.statusCode === 200){

        this.businessData.name = res?.data?.name
        this.businessData.about = res?.data?.about
        this.businessData.email = res?.data?.email
        this.businessData.website = res?.data?.website
        this.businessData.facebook_url = res?.data?.facebook_url
        this.businessData.linked_url = res?.data?.linked_url
        this.businessData.phone = res?.data?.phone
        this.businessData.address = res?.data?.address
        this.businessData.refrences = res?.data?.refrences
        this.businessData.notes = res?.data?.notes
        this.businessData.admin_notes = res?.data?.admin_notes

        this.selected_type = res?.data?.type.map(item => item._id)
        this.businessData.type = this.selected_type

      }
    })
  }
  setFocus(event) {
    this.businessData.refrences = event.html
  }
  submit(){
    if (this.businessId) {
      if(this.businessData.type.length >0){
        this.businessData.type = this.selected_type
        this.apiService.updateBusiness(this.businessId,this.businessData).subscribe((res:any)=>{
          if(res.statusCode === 200){
             this.toastr.success('Updated Successfully',res.message)
          this.route.navigate(['/business/list'])
          }
          else{this.toastr.error(res.error)}  
        })
      }
      if(this.businessData.type.length <1){
        let newObject = Object.assign({}, this.businessData);
        delete newObject.type;
        this.apiService.updateBusiness(this.businessId,newObject).subscribe((res:any)=>{
          if(res.statusCode === 200){
             this.toastr.success('Updated Successfully',res.message)
          this.route.navigate(['/business/list'])
          }
          else{this.toastr.error(res.error)}  
        })
      }
      
    }
     else{
       alert('Something went Wrong!!!')
     }
  }
  back(){
    this.route.navigate(['/business/list'])
  }

  getTagByCategory(){
    this.apiService.getTagByTagCatgoryId("631ad8d1ce5c666542591bdd").subscribe((res:any)=>{
      this.categoryList=res.data
    })
   }
  getBusinessId(event) {
    this.selected_type
  }
}
